module.exports = __webpack_public_path__ + "img/multidevice_icon.759fd71f.png";